<template>
    <div class="" :class="{'collapsible-item' : true, open: active}" v-on="$listeners">
        <div :class="{disabled: disabled}" class="title">
            <span class="">{{ title }}</span>
            <font-awesome-icon :icon="icon" class="icon"/>
        </div>
        <div class="body">
            <div class="content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AccordionTab",

        props : ['title', 'active', 'disabled'],

        computed : {
            icon () {
                return this.active ? 'chevron-down' : 'chevron-right';
            }
        }
    }
</script>

<style scoped lang="scss">
    .body {
        padding-bottom: 0.5em;
        position: relative;
        top: -4px;
        max-height: 0;
        overflow: hidden;
        border: 1px solid #ccc;
        border-top: 0;
        z-index: -1;
        transition: max-height 0.5s ease;

        .content {
            padding: 20px 15px 5px 15px;
        }
    }

    .open {
        .body {
            max-height: 1000px;
            z-index: 1;
        }
    }

    .collapsible-item {
        margin-bottom: 10px;

        .title {
            border-radius: 5px 5px 0 0;
            padding: 10px;
            background-color: #f5f5f5;
            background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, #ffffff), color-stop(0, #E2D5A5));

            .icon {
                float: right;
                height: 20px;
                width: 20px;
                font-size: 19px !important;
                padding-right: 1px;
            }
        }
    }
</style>